export default __webpack_public_path__ + "static/media/2022_Ke_2022_NatureEcolEvol.3d0371e7.pdf";